
import { importContractsFromCsv, exportContractsToCsv } from "../../../services/contractsImportExport";
import { deleteContract } from "../../../services/contractService";

export const contractsMapping = {
  importFn: async (file: File) => {
    return await importContractsFromCsv(file);
  },
  exportFn: async (data: any[]) => {
    // Note: The existing exportContractsToCsv fetches from DB directly, 
    // but here we might want to export the filtered view or just call the global export.
    // For consistency with the requested API, we just call the existing service.
    return await exportContractsToCsv();
  },
  deleteFn: async (id: string, row: any) => {
    // Use the specific service to ensure related events are deleted
    await deleteContract(id, row.contractNo || "");
  }
};
